var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 2.29102L6.875 11.4577V25.2077C6.875 37.9264 15.675 49.8202 27.5 52.7077C39.325 49.8202 48.125 37.9264 48.125 25.2077V11.4577L27.5 2.29102ZM27.5 11.2285C28.8597 11.2285 30.189 11.6317 31.3195 12.3872C32.4501 13.1426 33.3313 14.2163 33.8517 15.4726C34.372 16.7288 34.5082 18.1111 34.2429 19.4448C33.9776 20.7784 33.3228 22.0034 32.3614 22.9649C31.3999 23.9264 30.1749 24.5811 28.8412 24.8464C27.5076 25.1117 26.1253 24.9755 24.8691 24.4552C23.6128 23.9348 22.5391 23.0536 21.7836 21.9231C21.0282 20.7925 20.625 19.4633 20.625 18.1035C20.625 16.2802 21.3493 14.5315 22.6386 13.2422C23.928 11.9528 25.6766 11.2285 27.5 11.2285ZM27.5 29.3327C32.0833 29.3327 41.25 31.8306 41.25 36.391C39.7449 38.66 37.7017 40.5213 35.3025 41.8089C32.9033 43.0965 30.2228 43.7703 27.5 43.7703C24.7772 43.7703 22.0967 43.0965 19.6975 41.8089C17.2983 40.5213 15.2551 38.66 13.75 36.391C13.75 31.8306 22.9167 29.3327 27.5 29.3327Z",
    fill: "#548170"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/admin_icon.0f0af2c85a7432e246d8e834438ef4b1.svg";
export { ForwardRef as ReactComponent };